module.exports = __webpack_public_path__ + "img/mic-off.74a78497.svg";